module.exports = __webpack_public_path__ + "static/media/convex-hull-part-2.861edb9d.md";